//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed, ref, watch } from '@nuxtjs/composition-api';
export default defineComponent({
  props: {
    vid: {
      type: String,
      default: null,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    debounce: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: 'text',
    },
    passwordReveal: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    const innerValue = ref(props.value);
    const computedValue = computed({
      get: () => innerValue.value,
      set: (value) => {
        innerValue.value = value;
        context.emit('input', value);
      },
    });

    const changeHandler = (value) => {
      computedValue.value = value;
    };

    watch(
      () => props.value,
      (newValue, _oldValue) => {
        innerValue.value = newValue;
      }
    );
    return {
      computedValue,
      changeHandler,
    };
  },
});
